import { ChannelPartnerFeatureFlag } from '../../../../shared/typings/request';
import { NextScreenState } from '../../../../shared/typings/screens';
import { WabaIntegration } from '../../../../shared/typings/waba';

export interface ChannelPartnerDetails {
  id: string;
  name: string;
  supportNumber: string;
  ownerId: string;
  logoUrl: string;
  domain: string;
  isOwner: boolean;
  privacyLink: string;
  tearOfServiceLink: string;
  recapthcaSiteKey: string;
  firebaseApiKey: string;
  featureFlags: ChannelPartnerFeatureFlag;
}
export interface VerifyOtpResponse {
  organizations: Array<Organization>;
  token: string;
  user: {
    countryCode: string;
    isOnWhatsapp: boolean;
    phone: string;
    isNewUser?: boolean;
  };
  nextScreenState: NextScreenState;
  channelPartnerDetails: ChannelPartnerDetails | null;
}

export interface Organization {
  orgId: string;
  name: string;
  domain: string | null;
  pictureUrl: string | null;
  isIntegrationEnabled: boolean;
  dateCreated?: string;
  inviteId?: string | null;
  isDemo?: boolean;
  isOwner: boolean;
  wabaPhoneNumber?: number;
}

export interface UserSignupDetails {
  firstName: string;
  lastName: string;
  orgName: string;
  designation: string;
  websiteUrl?: string;
  email?: string;
  isEmailVerified?: boolean;
  isWebsiteRequired: boolean;
}

export interface UserEmail {
  email: string;
  isVerified: boolean;
}

export interface AddEmailResponse {
  emailCode: string;
}

export interface VerifyEmailResponse {
  orgId: string;
}

export interface VerifyValidWhatsapp {
  phone: string;
  isValid: boolean;
}

export interface PhoneNumber {
  countryCode: string;
  countrySymbol: string;
  countryId: string;
  phone: string;
}

export enum UserAction {
  SEND_AND_RECEIVE_MESSAGES = 'sendAndReceiveMessages',
  SEND_AND_RECEIVE_PRODUCTS = 'sendAndReceiveProducts',
}

export interface ReceiveTestMessage {
  message: string;
  wabaPhoneNumber: string;
}

export enum OTPServices {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export enum TechProviderProgress {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface EmbedAutoLoginRequest {
  userId: string;
  sessionId?: string;
  portalId?: string;
  embedClient?: EmbedClient;
  wabaNumber?: string;
}
export interface EmbedAutoLoginResponse {
  organization: Organization;
  integrations: WabaIntegration[];
  token: string;
  idToken: string;
  user: {
    countryCode: string;
    isOnWhatsapp: boolean;
    phone: string;
    isNewUser?: boolean;
  };
  nextScreenState: NextScreenState;
}

export enum EmbedClient {
  SALESFORCE = 'salesforce',
  SALESFORCEV2 = 'salesforceV2',
  DYNAMICS365 = 'dynamics365',
}

export interface LoginByEmailResponse {
  emailDomain: string;
  saml?: {
    providerId: string;
  };
  oidc?: {
    providerId: string;
  };
  secret: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
}

export enum LoginMethods {
  PHONE = 'phone',
  SSO = 'sso',
}

export interface RecaptchaFallbackResponse {
  whitelisted: boolean;
}
